// extracted by mini-css-extract-plugin
export default {"emptyArea":"isEmpty_emptyArea__v+AwH","small":"isEmpty_small__RNwz8"};